import AEMWrapper from "aem/ComponentWrapper";
import ContainerWrapper from "concierge-alias-aem/ContainerWrapper";
import meta from "./aem-meta";
import Component from "./aem-component";

export default AEMWrapper(meta, Component, {
  wrapper: ContainerWrapper
});
